import React from "react";
import {
  ActivityLogCardCommonProps,
  ActivityLogCardProps,
} from "../activityLogTypes";
import { ChangedTextActivityCard } from "./ChangedTextActivityCard";
import { AggregatedChangesActivityCard } from "./AggregatedChangesActivityCard";
import { useTranslations } from "@adsk/acc-issues-translations";

export const IssueDeletedActivityCard = ({
  comment,
  commonActivityBlockProps,
  ...props
}: ActivityLogCardProps & {
  comment: { displayName: string } | undefined;
  commonActivityBlockProps: ActivityLogCardCommonProps;
}) => {
  const { T } = useTranslations();
  if (!comment) {
    return <ChangedTextActivityCard {...props} />;
  }
  const activityItems = [
    {
      label: T.translate("activityLog.deletedIssueCommentWasAdded"),
      value: comment.displayName,
    },
  ];
  return (
    <AggregatedChangesActivityCard
      {...commonActivityBlockProps}
      key={commonActivityBlockProps.key}
      title={props.title}
      activityItems={activityItems}
    />
  );
};
